export default {
    name: 'Banners'
}
